import { render, staticRenderFns } from "./SavePictogramModal.vue?vue&type=template&id=0a7fa3d4&scoped=true"
import script from "./SavePictogramModal.vue?vue&type=script&lang=js"
export * from "./SavePictogramModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7fa3d4",
  null
  
)

export default component.exports